// ERP response types
export interface CityFacts {
  population?: number;
  timeZone: string | null;
}

export interface CountryFacts {
  currencyCode: string;
}

export interface IMTFactsResponse {
  cityFacts: CityFacts;
  countryFacts: CountryFacts | null;
}

export interface IMTTripReservingDetails {
  tripId: number;
  date: string;
  pricePerPassenger: number;
  durationAsNights: number;
  extendableHotelPhaseNights: number | null;
}

// NOTE: Actually the API can return other types as well (ships, trains etc) but only these are in use in TIM for now
export enum IMTTripPhaseType {
  SHIP = 'Ship',
  FLIGHT = 'Flight',
  HOTEL = 'Hotel'
}

export interface IMTTripPhaseCities {
  phaseType: IMTTripPhaseType;
  departureCity: {
    name: string;
  };
  arrivalCity: {
    name: string;
  };
}
